/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Button,
  Col,
  Form,
  Layout,
  List,
  Modal,
  Row,
  Select,
  Skeleton,
  Tag,
} from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { clearResponse } from "../../../Actions/message";
import { validateConcurrentLogin } from "../../../Actions/api";
import { history } from "../../../Helpers/history";
import NeedAuthService from "../../../Services/needAuth.service";
import NotNeedAuthService from "../../../Services/notNeedAuth.service";
import "./css/product.css";
import Documentation from "./documentation";
import Sandbox from "./sandbox";
import jwt_decode from "jwt-decode";
import TokenPage from "./token";
import { DownloadOutlined } from "@ant-design/icons";
import Cookies from "js-cookie";

const API_Product = () => {
  const { isLoggedIn } = useSelector((state) => state.auth);

  const token = Cookies.get("JWToken");

  const { APIProductCategory, Market } = useParams();

  const dispatch = useDispatch();
  const { Sider, Content } = Layout;

  const [Product, setProduct] = useState([]);
  const [countryList, setCountry] = useState([]);
  const [categoryList, setCategory] = useState([]);
  const [optionCategory, setOptionCategory] = useState([]);
  const [APIAccountInfo, setAPIAccount] = useState([]);
  //const [APIUserIdInfo, setAPIUserId] = useState(0);
  const [APPIdInfo, setAPPId] = useState([]);
  const [loading, setLoading] = useState(true);
  const [versionList, setVersionList] = useState([]);
  const [checkPayment, setCheckPayment] = useState([]);
  const [fileName, setFileName] = useState("");
  const [categoryId, setCategoryId] = useState(0);
  const [categoryName, setCategoryName] = useState("");

  const getCountryList = () => {
    const optionCountry = [];
    NotNeedAuthService.getCountryList().then((response) => {
      for (var i = 0; i <= response.Data.length - 1; i++) {
        var CountryName = response.Data[i].CountryName;
        var CountryCode = response.Data[i].CountryCode;
        optionCountry.push({
          label: CountryName,
          value: CountryCode,
          key: CountryCode,
        });
      }
      setCountry(optionCountry);
    });
  };

  const getCategoryId = (partnerId) => {
    const optionCategory = [];
    NeedAuthService.getCategory(partnerId, 0).then((response) => {
      var Id = 0;
      for (var i = 0; i <= response.Data.length - 1; i++) {
        var CategoryName = response.Data[i].Name;
        var CategoryHref = CategoryName.replace(/\s/g, "-");
        var CategoryType = response.Data[i].CategoryType;
        var Country = response.Data[i].Country.split(",");
        if (CategoryType !== "OTHER") {
          for (var p = 0; p <= Country.length - 1; p++) {
            if (Country[p] !== "") {
              optionCategory.push({
                country: Country[p],
                label: CategoryName,
                value: CategoryHref,
              });
            }
          }
        }
        if (CategoryHref === APIProductCategory) {
          Id = response.Data[i].Id;
          setCategoryId(Id);
          setFileName(CategoryHref);
          getCategory(partnerId, Id);
        }
      }
      setCategory(optionCategory);
      if (Id === 0) {
        history.push("/APIs");
      } else {
        form.setFieldsValue({
          Market: Market,
          APIProducts: APIProductCategory,
        });
      }
    });
  };

  //auth
  const getCategory = (id, categoryId) => {
    const array = [];
    const storeVersion = [];
    const checkPYArray = [];
    NeedAuthService.getCategory(id, categoryId).then((response) => {
      for (var i = 0; i <= response.Data.length - 1; i++) {
        var CategoryName = response.Data[i].Name;
        var CategoryValue = CategoryName.replace(/\s/g, "-");
        var Product = response.Data[i].APIProducts;
        var VersionCatagory = response.Data[i].Version;
        var splitVersion = VersionCatagory.split(",");
        if (APIProductCategory === CategoryValue) {
          if (Product.length > 0) {
            for (var m = 0; m <= Product.length - 1; m++) {
              var productName = Product[m].ProductName;
              var method = Product[m].Method;
              var productDescription = Product[m].ProductDescription;
              var id = Product[m].Id;
              var doc = Product[m].ProductDocumentation;
              var request = Product[m].ProductRequestMessage;
              var ResponseSuccess = Product[m].ProductResponseSuccessMessage;
              var ResponseFailed = Product[m].ProductResponseFailedMessage;
              var ProductCategoryId = Product[m].APIProductCategoryId;
              var inbound = Product[m].InboundEndPoint;
              var version = Product[m].Version;
              var isPrivate = Product[m].isPrivate;
              if (window.location.hostname === "www.tiq.com.sg") {
                if (
                  inbound.toLowerCase().includes("createpolicy") ||
                  inbound.toLowerCase().includes("createproposal") ||
                  inbound.toLowerCase().includes("inforcepolicy") ||
                  inbound.toLowerCase().includes("applycoupon")
                ) {
                  checkPYArray.push(id);
                }
              }
              if (inbound.toLowerCase().includes("payment")) {
                checkPYArray.push(id);
              }
              if (
                inbound.includes("/ai/") ||
                inbound.includes("/v2/") ||
                inbound.includes("/xProtechHomeInsurance/")
              ) {
                if (method === 2) {
                  method = 2;
                }
              } else {
                if (method === 1) {
                  method = 1;
                }
              }
              array.push({
                title: productName,
                content: productDescription,
                method: method,
                id: id,
                doc: doc,
                request: request,
                ResponseSuccess: ResponseSuccess,
                ResponseFailed: ResponseFailed,
                inbound: inbound,
                ProductCategoryId: ProductCategoryId,
                version: version,
                isPrivate: isPrivate,
              });
            }

            for (var v = 1; v <= splitVersion.length - 1; v++) {
              var versionString = splitVersion[v];
              if (versionString !== "") {
                if (versionString.charAt(0) === "D") {
                  var str = versionString.substring(1);
                  storeVersion.push({
                    Deprecated: true,
                    version: parseInt(str),
                  });
                } else {
                  storeVersion.push({
                    Deprecated: false,
                    version: parseInt(versionString),
                  });
                }
              }
            }
          }
        }
      }
      var FinalStore = [];
      var firstTrue = false;
      var firstproduct = 0;
      for (var s = 0; s <= storeVersion.length - 1; s++) {
        var sVersion = storeVersion[s].version;
        var arrayVersion = [];
        for (var r = 0; r <= array.length - 1; r++) {
          var rVersion = array[r].version;
          if (!firstTrue) {
            if (!storeVersion[s].Deprecated) {
              if (sVersion === rVersion) {
                firstproduct = r;
                firstTrue = true;
              }
            }
          }
          if (sVersion === rVersion) {
            if (array[r].isPrivate === false) {
              arrayVersion.push({
                title: array[r].title,
                content: array[r].content,
                method: array[r].method,
                id: array[r].id,
                doc: array[r].doc,
                request: array[r].request,
                ResponseSuccess: array[r].ResponseSuccess,
                ResponseFailed: array[r].ResponseFailed,
                inbound: array[r].inbound,
                ProductCategoryId: array[r].ProductCategoryId,
                version: rVersion,
                isPrivate: array[r].isPrivate,
              });
            }
          }
        }
        FinalStore.push({
          Deprecated: storeVersion[s].Deprecated,
          version: sVersion,
          products: arrayVersion,
        });
      }
      setTitle(array[firstproduct].title);
      setContent(array[firstproduct].content);
      setFocus(array[firstproduct].id);
      setVersionList(FinalStore);
      setProduct(array);
      setCheckPayment(checkPYArray);
      setLoading(false);
    });
  };

  const getAPIAccount = (id) => {
    var APIAccountArray = [];
    var optionAPPID = [];
    NeedAuthService.getAPIAccount(id).then((response) => {
      for (var i = 0; i <= response.Data.length - 1; i++) {
        var id = response.Data[i].Id;
        var apiUserName = response.Data[i].APIUserName;
        var apiKey = response.Data[i].APIKey;
        var productAccount = response.Data[i].ProductAccount;
        APIAccountArray.push({
          id: id,
          apiUserName: apiUserName,
          apiKey: apiKey,
          key: i + 1,
          productAccount: productAccount,
        });
        optionAPPID.push({
          label: apiUserName,
          value: apiUserName,
          apiKey: apiKey,
          productAccount: productAccount,
        });
        if (i === 0) {
          form.setFieldsValue({
            appId: apiUserName,
            apiKey: apiKey,
          });
        }
      }
      // setAPIUserId(apiUserId);
      setAPIAccount(APIAccountArray);
      setAPPId(optionAPPID);
    });
  };

  const getUser = async () => {
    NeedAuthService.getUser().then((response) => {
      //   var userId = response.data.userId;
      var partnerId = response.Data.PartnerId;
      getAPIAccount(partnerId);
      getCategoryId(partnerId);
    });
  };

  const getCategoryOptionByCountry = (value) => {
    var array = [];
    var firstValue = "";
    var found = false;
    for (var i = 0; i <= categoryList.length - 1; i++) {
      if (categoryList[i].country === value) {
        var label = categoryList[i].label;
        var categoryValue = categoryList[i].value;
        array.push({ label: label, value: categoryValue });
        if (firstValue === "") {
          firstValue = categoryValue;
        }
        if (categoryValue === APIProductCategory) {
          found = true;
        }
      }
    }
    setOptionCategory(array);
    if (found) {
      form.setFieldsValue({
        APIProducts: APIProductCategory,
      });
    } else {
      form.setFieldsValue({
        APIProducts: firstValue,
      });
    }
  };

  const handleConcurrentLogin = (token) => {
    if (token !== undefined) {
      let concurrencyLoginStamp = localStorage.getItem("ConcurrencyLoginStamp");
      if (token && concurrencyLoginStamp) {
        var decodePayload = jwt_decode(token);
        dispatch(
          validateConcurrentLogin(decodePayload.uid, concurrencyLoginStamp)
        );
      }
    }
  };

  useEffect(() => {
    setLoading(true);
    getCountryList();
    if (isLoggedIn) {
      getUser();
      handleConcurrentLogin(token);
    }
  }, [APIProductCategory, Market]);

  useEffect(() => {
    getCategoryOptionByCountry(Market);
  }, [categoryList]);

  const product_nav = [
    {
      title: "Documentation",
      key: 1,
    },
    {
      title: "Token",
      key: 2,
    },
    {
      title: "Sandbox",
      key: 3,
    },
  ];

  const product_nav_without_auth = [
    {
      title: "Documentation",
      key: 1,
    },
  ];

  const layout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };

  const { Option } = Select;
  const [form] = Form.useForm();

  let className = "API_nav_item";
  let className_focus = "API_nav_item focus_nav";

  let className_product = "product_nav_item";
  let className_product_focus = "product_nav_item focus_product_nav";

  let className_display = "product_nav_component";
  let className_display_none = "product_nav_component_none";

  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  //const [productId, setProductId] = useState(0);
  const [focus, setFocus] = useState(0);
  const [focusProduct, setFocusProduct] = useState(1);
  const [visible, setVisible] = useState(false);

  const handleMenuClick = (list) => {
    dispatch(clearResponse());
    handleConcurrentLogin(token);
    if (token !== undefined) {
      let concurrencyLoginStamp = localStorage.getItem("ConcurrencyLoginStamp");
      if (token && concurrencyLoginStamp) {
        var decodePayload = jwt_decode(token);
        dispatch(
          validateConcurrentLogin(decodePayload.uid, concurrencyLoginStamp)
        );
      }
    }
    setFocus(list);
    for (var i = 0; i <= Product.length - 1; i++) {
      if (Product[i].id === list) {
        const s_title = Product[i].title;
        const s_content = Product[i].content;
        setTitle(s_title);
        setContent(s_content);
      }
    }
    if (checkPayment.includes(list)) {
      setFocusProduct(1);
    }
  };

  const handleProductNavClick = (list) => {
    setFocusProduct(list);
  };

  const onFinish = (values) => {
    history.push("/APIs/" + values.Market + "/" + values.APIProducts);
  };

  const downloadFile = () => {
    NeedAuthService.getPdf(categoryId, fileName);
  };

  return [
    <div style={{ backgroundColor: "#292929" }}>
      <Row justify="center" align="middle" className="banner-product">
        <Col xs={24} sm={4} md={8} lg={8} xl={5}></Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={14}>
          <p className="banner-product-title">
            {APIProductCategory.replace("-", " ")}
          </p>
        </Col>
        <Col xs={24} sm={4} md={8} lg={8} xl={5}></Col>
      </Row>
    </div>,
    <div className="select_country">
      <Row style={{ width: "98%" }}>
        <Col xs={24} sm={24} md={6} lg={6} xl={8} className="select_following">
          Select the following :
        </Col>
        <Col xs={24} sm={24} md={18} lg={18} xl={16}>
          <Form
            {...layout}
            form={form}
            layout="vertical"
            name="basic"
            onFinish={onFinish}
          >
            <Row justify="center" style={{ margin: 0 }} gutter={12}>
              <Col xs={22} sm={22} md={8} lg={7} xl={6}>
                <Form.Item
                  label={
                    <label style={{ color: "white", fontSize: "1rem" }}>
                      Market
                    </label>
                  }
                  name="Market"
                  className="s_item_c"
                >
                  <Select size="large" onChange={getCategoryOptionByCountry}>
                    {countryList.map((p) => (
                      <Option key={p.value}>{p.label}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={22} sm={22} md={8} lg={7} xl={6}>
                <Form.Item
                  label={
                    <label style={{ color: "white", fontSize: "1rem" }}>
                      API Product
                    </label>
                  }
                  className="s_item_c"
                  name="APIProducts"
                  rules={[
                    {
                      required: true,
                      message: "Please Select Your API Products",
                    },
                  ]}
                >
                  <Select size="large">
                    {optionCategory.map((c) => (
                      <Option key={c.value}>{c.label}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={22} sm={22} md={8} lg={7} xl={6}>
                <Button
                  className="selection_product_button"
                  size="large"
                  htmlType="submit"
                  block
                >
                  Show Documentation
                </Button>
              </Col>
              <Col xs={22} sm={22} md={8} lg={3} xl={6}></Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </div>,
    <div>
      <Row>
        <Col xs={24} sm={24} md={24} lg={1} xl={1}></Col>
        {loading === false ? (
          <>
            <Col xs={24} sm={24} md={24} lg={7} xl={5}>
              {versionList
                .sort((a, b) => (b.version > a.version ? 1 : -1))
                .map((array, id) => (
                  <React.Fragment key={id}>
                    <div className="version_menu_nav">
                      Version {array.version}{" "}
                      {array.Deprecated ? "(Deprecated)" : null}
                    </div>
                    <List
                      dataSource={array.products}
                      className="menu_nav"
                      renderItem={(item) => (
                        <List.Item
                          key={item.id}
                          onClick={() => handleMenuClick(item.id)}
                          className={
                            item.id === focus ? className_focus : className
                          }
                        >
                          <Skeleton
                            avatar
                            title={false}
                            loading={loading}
                            active
                          >
                            <List.Item.Meta
                              avatar={
                                item.method === 2 ? (
                                  <Tag
                                    color="#2db7f5"
                                    style={{ width: 50, textAlign: "center" }}
                                  >
                                    GET
                                  </Tag>
                                ) : (
                                  <Tag color="#349651" style={{ width: 50 }}>
                                    POST
                                  </Tag>
                                )
                              }
                              title={item.title}
                            />
                          </Skeleton>
                        </List.Item>
                      )}
                    />
                  </React.Fragment>
                ))}
            </Col>
            <Col xs={24} sm={24} md={24} lg={15} xl={17}>
              <div className="tip">
                <p className="tip_title">
                  Create credentials to access your enabled APIs. For more
                  information, see the{" "}
                  <a
                    onClick={() => setVisible(true)}
                    style={{ color: "green" }}
                  >
                    Guideline Documents
                  </a>
                  .
                </p>
              </div>
              <Modal
                title="Guideline Documents"
                centered
                visible={visible}
                onOk={() => setVisible(false)}
                onCancel={() => setVisible(false)}
                width={1000}
                footer={null}
              >
                <div>
                  <b className="guideline_step">
                    Step 1. Create Developer Account
                  </b>
                  <p>
                    Developer Account gives you access to Etiqa’s sandbox
                    environment. It is free of charge and you can create your
                    account instantly. your account is confirmed instantly.
                  </p>

                  <b className="guideline_step">Step 2. Activate and Login</b>
                  <p>
                    You will then receive an email with an activation link.
                    Login to Etiqa Developer Portal to view detailed
                    documentation of our APIs and generate access token. You are
                    ready to start developing.
                  </p>

                  <b className="guideline_step">
                    Step 3. Create An API Sandbox Account
                  </b>
                  <div>
                    Direct to Profile Page and add a new API Sandbox Account
                    that will follow your selected product to access the API.
                  </div>
                  <div>Click 'Add' Button</div>
                  <div>Select the Product Type and API Product Category</div>
                  <div>Click 'OK' Button</div>
                  <p>The New API Sandbox Account will created successfully.</p>

                  <b className="guideline_step">
                    Step 4. Choose One API Product
                  </b>
                  <div>Direct to API and Select one API Product Category.</div>
                  <p>That will direct to selected API product page.</p>

                  <b className="guideline_step">
                    Step 5. Generate access token
                  </b>
                  <div>
                    Proceed to Api Catalog and select a service to start
                    developing.
                  </div>
                  <div>Click "Token" tab</div>
                  <div>
                    Select that API sandbox account includes that API product.
                  </div>
                  <div>Click "GENERATE" button</div>
                  <div>Copy token!</div>
                  <p>
                    A token generated only valid for 15 minutes! Please
                    regenerate token if the token is invalid.
                  </p>

                  <b className="guideline_step">Step 6. Calling Api</b>
                  <div>Now direct to the "Sandbox" tab</div>
                  <div>
                    Please do checking on the json type, method, and api url.
                    Refer api documentation by click the "Documentation" tab to
                    get more information.
                  </div>
                  <div>Paste the access token in the token field</div>
                  <div>
                    Remember to update the values in message body according to
                    the format
                  </div>
                  <div>Click "Send" button!</div>
                  <p>
                    Api response or data message will be showing at the response
                    body.
                  </p>
                </div>
              </Modal>
              <Layout style={{ background: "white" }}>
                <div className="container_API_Product">
                  <div className="AC_title">
                    <Layout style={{ background: "white" }}>
                      <Row>
                        <Col xl={{span:12}} lg={{span: 12}} md={{span:12}} sm={{span:24}} xs={{span:24}}>
                          <h3 className="nav_title">{title}</h3>
                        </Col>
                        <Col xl={{span:5, offset: 7}} lg={{span:5, offset: 7}} md={{span:5, offset:7}} sm={{span:24}} xs={{span:24}}>
                          <Button
                              type="primary"
                              danger
                              shape="round"
                              onClick={downloadFile}
                              icon={<DownloadOutlined />}
                              size="large"
                              color="transparent"
                              target="_blank"
                            >
                              Download PDF
                            </Button>
                        </Col>
                      </Row>
                      {/* <Content>
                        <h3 className="nav_title">{title}</h3>
                      </Content>
                      <Sider style={{ background: "white" }}>
                        <Button
                          type="primary"
                          danger
                          shape="round"
                          onClick={downloadFile}
                          icon={<DownloadOutlined />}
                          size="large"
                          color="transparent"
                          target="_blank"
                        >
                          Download PDF
                        </Button>
                      </Sider> */}
                    </Layout>
                    <hr />
                    <p className="nav_content">{content}</p>
                  </div>
                  {isLoggedIn && APIAccountInfo.length === 0 ? (
                    <p style={{ color: "red" }}>
                      You haven't created your own APIs Sandbox Account. Please
                      redirect to <Link to="/Profile">Profile</Link> to do that.
                    </p>
                  ) : (
                    <></>
                  )}
                  <List
                    grid={{ column: 3 }}
                    dataSource={
                      isLoggedIn &&
                      APIAccountInfo.length > 0 &&
                      !checkPayment.includes(focus)
                        ? product_nav
                        : product_nav_without_auth
                    }
                    className="product_nav"
                    renderItem={(item) => (
                      <List.Item
                        key={item.key}
                        onClick={() => handleProductNavClick(item.key)}
                        className={
                          item.key === focusProduct
                            ? className_product_focus
                            : className_product
                        }
                      >
                        <span className="product_nav_item_text">
                          {item.title}
                        </span>
                      </List.Item>
                    )}
                  />
                  {APPIdInfo.length > 0 ? (
                    <>
                      <div
                        className={
                          focusProduct === 1
                            ? className_display
                            : className_display_none
                        }
                      >
                        <Documentation
                          product={Product}
                          productId={focus}
                          downloadFile={downloadFile}
                        />
                      </div>
                      <div
                        className={
                          focusProduct === 2
                            ? className_display
                            : className_display_none
                        }
                      >
                        <TokenPage
                          APPIdInfo={APPIdInfo}
                          APIAccountInfo={APIAccountInfo}
                          token={token}
                          categoryName={APIProductCategory}
                        />
                      </div>
                      <div
                        className={
                          focusProduct === 3
                            ? className_display
                            : className_display_none
                        }
                      >
                        <Sandbox
                          product={Product}
                          productId={focus}
                          focusProduct={setFocusProduct}
                          token={token}
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <div>
                        <Documentation
                          product={Product}
                          productId={focus}
                          downloadFile={downloadFile}
                        />
                      </div>
                    </>
                  )}
                </div>
              </Layout>
            </Col>
          </>
        ) : (
          <>
            <Col xs={24} sm={24} md={24} lg={22} xl={22}>
              <div>
                <br />
                <Skeleton active />
                <br />
                <Skeleton active />
                <br />
                <Skeleton active />
                <br />
                <br />
              </div>
            </Col>
          </>
        )}
      </Row>
    </div>,
  ];
};

export default API_Product;
